import { Alert } from "antd"

export type BannerTypes = 'error' | 'info' | 'success' | 'warning'

type BannerProps = {
  text: string;
  type?: BannerTypes;
}


function Banner({ text, type }: Readonly<BannerProps>): JSX.Element {
  return (
    <Alert
      showIcon
      type={type ?? "info"}
      closable={type === "success" || type === "error" ? true : false}
      className="banner"
      style={{ margin: "24px 16px 0 274px" }}
      message={text}
    />
  )
}

export default Banner
